export const collapsibleSections = () => {
  const collapsibleSection = ".js-collapsible-section";
  const collapsibleSectionToExpand = ".js-collapsible-section-to-expand";
  const collapsibleSectionToggle = ".js-collapsible-section-toggle";

  const init = () => {
    bind();
  };

  const bind = () => {
    console.log("collapsibleSections");
    $(collapsibleSectionToggle).on("click", function (e) {
      e.preventDefault();
      var $section = $(this).closest(collapsibleSection);
      var $toExpand = $section.children(collapsibleSectionToExpand);
      $section.attr(
        "data-state",
        $section.attr("data-state") == "closed" ? "open" : "closed"
      );
      if ($section.attr("data-state") == "open") {
        $toExpand.css({
          height: $toExpand
            .children(".js-collapsible-section-content")
            .outerHeight(),
        });
      } else {
        $toExpand.css({ height: 0 });
      }
    });
  };

  init();
  
};
